import React, { Component } from "react";

import "./styles.css";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CSelect,
  CInput,
  CRow,
  CCol,
  CBadge
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ClassroomCreate extends Component {
  constructor(props) {
    super(props);

    // NOVO: Mapeamento das disciplinas padrão por série
    this.defaultDisciplinesBySerie = {
      // 5 anos (6), 4 anos (5)
      5: [18, 1, 35],
      6: [18, 1, 35],
      // Berçário 1 (1), Berçário 2 (2), 2 anos (3), 3 anos (4)
      1: [24, 25, 26, 27, 28],
      2: [24, 25, 26, 27, 28],
      3: [24, 25, 26, 27, 28],
      4: [24, 25, 26, 27, 28],
      // 1º ao 9º ano EF (7–15)
      7: [1, 5, 8, 9, 10],
      8: [1, 5, 8, 9, 10],
      9: [1, 5, 8, 9, 10],
      10: [1, 5, 8, 9, 10],
      11: [1, 5, 8, 9, 10],
      12: [1, 5, 8, 9, 10],
      13: [1, 5, 8, 9, 10],
      14: [1, 5, 8, 9, 10],
      15: [1, 5, 8, 9, 10],
      // 1º ao 4º ano EM (16–19)
      16: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      17: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      18: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11],
      19: [1, 5, 8, 9, 3, 2, 4, 12, 7, 13, 11]
    };

    // NOVO: Opções para o campo complemento
    this.complementoOptions = [
      // Letras
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "C", label: "C" },
      { value: "D", label: "D" },
      { value: "E", label: "E" },
      { value: "F", label: "F" },
      { value: "G", label: "G" },
      { value: "H", label: "H" },
      { value: "I", label: "I" },
      { value: "J", label: "J" },
      { value: "K", label: "K" },
      // Números romanos
      { value: "I", label: "I" },
      { value: "II", label: "II" },
      { value: "III", label: "III" },
      { value: "IV", label: "IV" },
      { value: "V", label: "V" },
      { value: "VI", label: "VI" },
      { value: "VII", label: "VII" },
      { value: "VIII", label: "VIII" },
      { value: "IX", label: "IX" },
      { value: "X", label: "X" }
    ];

    this.state = {
      edit: false,
      loading: false,
      room: null,
      optionsGroup: [{ value: null, name: "Carregando" }],
      optionsRegion: [{ value: null, name: "Carregando" }],
      optionsSchool: [{ value: null, name: "Carregando" }],
      optionsPeriod: [{ value: null, name: "Carregando" }],
      group_id: null,
      region_id: null,
      school_id: null,
      selectedDisciplines: [],
      disciplines: [],
      series: [],
      creating: false,
      customForm: {
        name: "",
        sigla: "", // NOVO: Campo sigla
        complemento: "", // NOVO: Campo complemento
        period_id: "",
        year: new Date().getFullYear().toString(),
        start: new Date(new Date().getFullYear(), 0, 1)
          .toISOString()
          .split("T")[0],
        end: new Date(new Date().getFullYear(), 11, 31)
          .toISOString()
          .split("T")[0]
      },
      isReviewMode: false,
      selectedSeries: [],
      isMultiSerie: false
    };

    this.formRef = React.createRef();
    this.customFormRef = React.createRef();
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  // NO ClassroomCreate.js - adicione este método dentro da classe

  getSwitchStyles = () => ({
    // INTERRUPTOR PRINCIPAL
    switch: {
      position: "relative",
      display: "inline-block",
      width: "40px",
      height: "15px"
    },

    switchInput: {
      opacity: 0,
      width: 0,
      height: 0
    },

    switchSlider: {
      position: "absolute",
      cursor: "pointer",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#ccc",
      transition: "0.4s",
      borderRadius: "10px",
      boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)"
    },

    switchSliderBefore: {
      position: "absolute",
      content: '""',
      height: "10px",
      width: "10px",
      left: "2px",
      bottom: "2px",
      backgroundColor: "white",
      transition: "0.4s",
      borderRadius: "50%",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)"
    },

    // ESTADO ATIVO
    switchChecked: {
      backgroundColor: "#02517d"
    },

    switchSliderBeforeChecked: {
      transform: "translateX(26px)"
    },

    // VERSÃO PEQUENA
    switchSm: {
      width: "5px",
      height: "5px"
    },

    switchSmSliderBefore: {
      height: "8px",
      width: "8px",
      left: "4px",
      bottom: "4px"
    },

    switchSmSliderBeforeChecked: {
      transform: "translateX(20px)"
    },

    // ESTADOS ESPECIAIS
    switchFocus: {
      boxShadow: "0 0 1px #02517d, 0 0 0 3px rgba(2, 81, 125, 0.1)"
    },

    switchDisabled: {
      opacity: 0.6,
      cursor: "not-allowed",
      backgroundColor: "#e9ecef"
    },

    switchDisabledChecked: {
      backgroundColor: "#7aa7c4"
    },

    // CORES ALTERNATIVAS
    switchPrimary: {
      backgroundColor: "#321fdb"
    },

    switchSuccess: {
      backgroundColor: "#2eb85c"
    },

    switchDanger: {
      backgroundColor: "#e55353"
    },

    // ESTILOS PARA SELECT DESABILITADO
    selectDisabled: {
      opacity: "1 !important",
      backgroundColor: "#e9ecef !important",
      color: "#495057 !important"
    },

    inputGroupDisabled: {
      borderLeft: "none",
      borderRadius: "0 0.25rem 0.25rem 0"
    },

    inputGroupSelectDisabled: {
      backgroundColor: "#e9ecef",
      opacity: 1
    }
  });

  // MÉTODO PARA APLICAR ESTILOS DINÂMICOS
  getDynamicStyles = () => {
    const styles = this.getSwitchStyles();
    const { isMultiSerie, creating } = this.state;

    return {
      // Estilos base
      ...styles,

      // Estilos dinâmicos baseados no estado
      switchSliderDynamic: {
        ...styles.switchSlider,
        ...(isMultiSerie ? styles.switchChecked : {}),
        ...(creating ? styles.switchDisabled : {})
      },

      switchSliderBeforeDynamic: {
        ...styles.switchSliderBefore,
        ...(isMultiSerie ? styles.switchSliderBeforeChecked : {})
      }
    };
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = [];
          respGroup.data.data.forEach(group => {
            optionsGroup.push({ value: group.id, name: group.name });
          });

          this.setState({ optionsGroup });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}access/region/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respRegion => {
          const optionsRegion = [];
          respRegion.data.data.forEach(region => {
            optionsRegion.push({
              value: region.id,
              name: region.name,
              group_id: region.group_id
            });
          });

          this.setState({ optionsRegion });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}access/school/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSchool => {
          const optionsSchool = [];
          respSchool.data.data.forEach(school => {
            optionsSchool.push({
              value: school.id,
              name: school.name,
              region_id: school.region_id
            });
          });

          this.setState({ optionsSchool });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}community/period/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respPeriod => {
          this.setState({
            optionsPeriod: respPeriod.data.data.map(period => ({
              value: period.id,
              name: period.name
            }))
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}classification/serie/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSeries => {
          this.setState({
            series: respSeries.data.data.map(serie => ({
              value: serie.id,
              label: serie.name
            }))
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    axios
      .get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respDisciplines => {
          this.setState({
            disciplines: respDisciplines.data.data.map(serie => ({
              value: serie.id,
              label: serie.name
            }))
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    const { id } = this.props.match.params;

    if (id) {
      this.setState(
        () => ({ loading: true }),
        () => {
          axios
            .get(`${URL.api}community/room/singleView/${id}`, {
              headers: { Authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                const roomData = resp.data.data.room;
                const roomDisciplines = resp.data.data.room_discipline || [];

                // NOVO: Detectar se é turma multisseriada baseado nas disciplinas
                const isMultiSerie =
                  this.detectMultiSerieFromDisciplines(roomDisciplines);

                // Encontra a série baseada nas disciplinas existentes
                const uniqueSeriesIds = [
                  ...new Set(roomDisciplines.map(item => item.serie_id))
                ];
                const selectedSeries = uniqueSeriesIds
                  .map(serieId =>
                    this.state.series.find(s => s.value === serieId)
                  )
                  .filter(Boolean);

                // NOVO: Classificar disciplinas do back-end
                const classifiedDisciplines =
                  this.classifyDisciplinesFromBackend(
                    roomDisciplines,
                    selectedSeries
                  );

                // Parse do nome existente para extrair sigla e complemento
                const { sigla, complemento } = this.parseExistingName(
                  roomData.name
                );

                this.setState(
                  () => ({
                    room: roomData,
                    selectedDisciplines: classifiedDisciplines,
                    group_id: roomData.group_id,
                    region_id: roomData.region_id,
                    school_id: roomData.school_id,
                    selectedSeries,
                    isMultiSerie, // NOVO: Setar o estado do interruptor
                    customForm: {
                      name: roomData.name || "",
                      sigla: sigla || "",
                      complemento: complemento || "",
                      period_id: roomData.period_id || "",
                      year: roomData.start
                        ? new Date(roomData.start).getFullYear().toString()
                        : new Date().getFullYear().toString(),
                      start: roomData.start ? roomData.start.split(" ")[0] : "",
                      end: roomData.end ? roomData.end.split(" ")[0] : ""
                    }
                  }),
                  () => {
                    if (selectedSeries.length > 0) {
                      setTimeout(() => {
                        this.loadDefaultDisciplinesForMultipleSeries(
                          selectedSeries.map(s => s.value)
                        );
                      }, 100);
                    }
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              }
            });
        }
      );
    } else {
      this.setState({
        group_id: this.props.general.active_roles.group_id,
        region_id: this.props.general.active_roles.region_id,
        school_id: this.props.general.active_roles.school_id
      });
    }
  }

  // NOVA FUNÇÃO: Gerar datas de início e fim baseadas no ano letivo
  gerarDatasDoAnoLetivo = year => {
    const ano = parseInt(year);
    return {
      start: `${ano}-01-01`, // 01 de Janeiro do ano
      end: `${ano}-12-31` // 31 de Dezembro do ano
    };
  };

  // NOVA FUNÇÃO: Detectar automaticamente se a turma é multisseriada baseada nas disciplinas
  detectMultiSerieFromDisciplines = roomDisciplines => {
    if (!roomDisciplines || roomDisciplines.length === 0) {
      return false;
    }

    // Obter todas as séries únicas das disciplinas
    const uniqueSeries = [
      ...new Set(roomDisciplines.map(item => item.serie_id))
    ];

    // Se há mais de uma série única, é uma turma multisseriada
    return uniqueSeries.length > 1;
  };

  renderMultiSerieToggle() {
    return (
      <div className="d-flex align-items-center">
        {/* Ícone + Texto + Toggle tudo em uma linha */}
        <i
          className="fa fa-info-circle mr-1"
          data-toggle="tooltip"
          data-placement="top"
          title="Turma Multisseriada: Permite selecionar múltiplas séries na mesma turma. Ideal para turmas mistas ou com alunos de diferentes níveis."
          style={{
            color: "#6c757d",
            fontSize: "0.8rem",
            cursor: "help"
          }}
        ></i>

        <span
          className="text-muted small mr-2"
          style={{
            fontSize: "0.8rem",
            fontWeight: "500"
          }}
        >
          Tipo da turma:
        </span>

        {/* Texto Padrão */}
        <span
          className="text-muted small mr-2"
          style={{
            fontSize: "0.8rem",
            color: !this.state.isMultiSerie ? "#02517d" : "#6c757d",
            fontWeight: !this.state.isMultiSerie ? "600" : "400"
          }}
        >
          Padrão
        </span>

        {/* Toggle */}
        <label
          style={{
            position: "relative",
            display: "inline-block",
            width: "40px",
            height: "22px",
            margin: "0 4px",
            cursor: this.state.creating ? "not-allowed" : "pointer"
          }}
        >
          <input
            type="checkbox"
            style={{ display: "none" }}
            checked={this.state.isMultiSerie}
            onChange={this.handleMultiSerieToggle.bind(this)}
            disabled={this.state.creating}
          />

          {/* Trilha */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: this.state.isMultiSerie ? "#02517d" : "#d7d7d7",
              borderRadius: "6px",
              transition: "all 0.3s",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.2)"
            }}
          />

          {/* Botão Quadrado */}
          <div
            style={{
              position: "absolute",
              top: "3px",
              left: this.state.isMultiSerie ? "20px" : "3px",
              width: "16px",
              height: "16px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              transition: "all 0.3s"
            }}
          />
        </label>

        {/* Texto Multisseriada */}
        <span
          className="text-muted small ml-2"
          style={{
            fontSize: "0.8rem",
            color: this.state.isMultiSerie ? "#02517d" : "#6c757d",
            fontWeight: this.state.isMultiSerie ? "600" : "400"
          }}
        >
          Multisseriada
        </span>
      </div>
    );
  }

  handleMultiSerieToggle(event) {
    const isMultiSerie = event.target.checked;

    // CORREÇÃO: Sempre limpar as séries e disciplinas ao mudar o modo
    this.setState(prevState => ({
      isMultiSerie,
      selectedSeries: [], // SEMPRE limpar as séries ao mudar de modo
      selectedDisciplines: [], // Limpar todas as disciplinas
      customForm: {
        ...prevState.customForm,
        name: ""
      }
    }));
  }

  // NOVA FUNÇÃO: Atualizar nome sugerido
  updateSuggestedName = () => {
    const nomeSugerido = this.gerarNomeSugerido();
    if (nomeSugerido) {
      this.setState(prevState => ({
        customForm: {
          ...prevState.customForm,
          name: nomeSugerido
        }
      }));
    }
  };

  // MODIFICAÇÃO: Atualizar a função loadDefaultDisciplinesForMultipleSeries para melhor integração
  loadDefaultDisciplinesForMultipleSeries = serieIds => {
    if (!serieIds || serieIds.length === 0) {
      this.setState({
        selectedDisciplines: []
      });
      return;
    }

    this.setState(state => {
      // Obter todas as disciplinas padrão únicas de todas as séries selecionadas
      const allDefaultDisciplines = new Map();

      serieIds.forEach(serieId => {
        const defaultIds = this.defaultDisciplinesBySerie[serieId] || [];
        defaultIds.forEach(disciplineId => {
          if (!allDefaultDisciplines.has(disciplineId)) {
            allDefaultDisciplines.set(disciplineId, {
              serie: serieId,
              discipline: disciplineId,
              isDefault: true
            });
          }
        });
      });

      const defaultDisciplinesSelected = Array.from(
        allDefaultDisciplines.values()
      );

      // Para edição: manter disciplinas existentes e garantir que as padrão estão marcadas como tal
      if (state.edit) {
        const existingDisciplines = state.selectedDisciplines || [];

        // Atualizar o status isDefault das disciplinas existentes
        const updatedExistingDisciplines = existingDisciplines.map(item => {
          const isDefault = defaultDisciplinesSelected.some(
            defaultDisc => defaultDisc.discipline === item.discipline
          );
          return {
            ...item,
            isDefault
          };
        });

        // Adicionar disciplinas padrão que estão faltando
        const missingDefaultDisciplines = defaultDisciplinesSelected.filter(
          newDisc =>
            !updatedExistingDisciplines.some(
              existingDisc => existingDisc.discipline === newDisc.discipline
            )
        );

        const combinedDisciplines = [
          ...updatedExistingDisciplines,
          ...missingDefaultDisciplines
        ];

        return {
          defaultDisciplines: state.disciplines.filter(d =>
            defaultDisciplinesSelected.some(dds => dds.discipline === d.value)
          ),
          selectedDisciplines: combinedDisciplines
        };
      }

      // Para criação: usar apenas as disciplinas padrão únicas
      return {
        defaultDisciplines: state.disciplines.filter(d =>
          defaultDisciplinesSelected.some(dds => dds.discipline === d.value)
        ),
        selectedDisciplines: defaultDisciplinesSelected
      };
    });
  };

  //  Função para parsear nome existente e extrair sigla e complemento
  parseExistingName = name => {
    if (!name) return { sigla: "", complemento: "" };

    const parts = name.split(" - ");
    let sigla = "";
    let complemento = "";

    // Padrão comum: "Série - Sigla - Turno" ou "Série - Sigla - Turno - Complemento"
    if (parts.length >= 3) {
      // A sigla geralmente está na segunda parte (índice 1)
      const possibleSigla = parts[1];

      // Verifica se é uma das opções válidas do select
      const isValidSigla = this.complementoOptions.some(
        option => option.value === possibleSigla
      );

      if (isValidSigla) {
        sigla = possibleSigla;

        // Se tiver 4 partes, a última pode ser o complemento
        if (parts.length >= 4) {
          const possibleComplemento = parts[parts.length - 1];
          const isValidComplemento = this.complementoOptions.some(
            option => option.value === possibleComplemento
          );
          if (isValidComplemento) {
            complemento = possibleComplemento;
          }
        }
      }
    }
    return { sigla, complemento };
  };

  gerarNomeSugerido = () => {
    const { selectedSeries, customForm } = this.state;

    if (
      selectedSeries.length === 0 ||
      !customForm.sigla ||
      !customForm.period_id
    ) {
      return "";
    }

    const serieNames = selectedSeries.map(serie => serie.label).join(" / ");
    const sigla = customForm.sigla.toUpperCase();
    const periodo = this.state.optionsPeriod.find(
      p => p.value == customForm.period_id
    )?.name;
    const complemento = customForm.complemento;

    const parts = [serieNames, sigla, periodo];
    if (complemento) {
      parts.push(complemento);
    }

    return parts.join(" - ");
  };

  // NOVO: Gerar opções de anos letivos (do ano atual até +2 anos no futuro)
  gerarOpcoesAnoLetivo() {
    const currentYear = new Date().getFullYear();
    const years = [];

    // Oferecer anos: atual, +1, +2
    for (let i = 0; i < 3; i++) {
      const year = currentYear + i;
      years.push({
        value: year.toString(),
        label: year.toString()
      });
    }

    return years;
  }

  handleCustomFormChange(event) {
    const { name, value } = event.target;

    this.setState(
      prevState => ({
        customForm: {
          ...prevState.customForm,
          [name]: value
        }
      }),
      () => {
        // Quando o ano letivo mudar, atualizar automaticamente as datas
        if (name === "year" && value) {
          const { start, end } = this.gerarDatasDoAnoLetivo(value);
          this.setState(prevState => ({
            customForm: {
              ...prevState.customForm,
              start,
              end
            }
          }));
        }

        if (["sigla", "complemento", "period_id"].includes(name)) {
          const nomeSugerido = this.gerarNomeSugerido();
          if (nomeSugerido) {
            this.setState(prevState => ({
              customForm: {
                ...prevState.customForm,
                name: nomeSugerido
              }
            }));
          }
        }
      }
    );
  }

  loadDefaultDisciplinesForMultipleSeries = serieIds => {
    if (!serieIds || serieIds.length === 0) {
      this.setState({
        selectedDisciplines: []
      });
      return;
    }

    this.setState(state => {
      // Obter todas as disciplinas padrão únicas de todas as séries selecionadas
      const allDefaultDisciplines = new Map();

      serieIds.forEach(serieId => {
        const defaultIds = this.defaultDisciplinesBySerie[serieId] || [];
        defaultIds.forEach(disciplineId => {
          // Garantir que cada disciplina padrão seja associada à série correta
          const key = `${serieId}-${disciplineId}`;
          if (!allDefaultDisciplines.has(key)) {
            allDefaultDisciplines.set(key, {
              serie: serieId,
              discipline: disciplineId,
              isDefault: true
            });
          }
        });
      });

      const defaultDisciplinesSelected = Array.from(
        allDefaultDisciplines.values()
      );

      // Para edição: manter disciplinas existentes e garantir que as padrão estão marcadas como tal
      if (state.edit) {
        const existingDisciplines = state.selectedDisciplines || [];

        // Atualizar o status isDefault das disciplinas existentes
        const updatedExistingDisciplines = existingDisciplines.map(item => {
          const isDefault = defaultDisciplinesSelected.some(
            defaultDisc =>
              defaultDisc.discipline === item.discipline &&
              defaultDisc.serie === item.serie
          );
          return {
            ...item,
            isDefault
          };
        });

        // Adicionar disciplinas padrão que estão faltando
        const missingDefaultDisciplines = defaultDisciplinesSelected.filter(
          newDisc =>
            !updatedExistingDisciplines.some(
              existingDisc =>
                existingDisc.discipline === newDisc.discipline &&
                existingDisc.serie === newDisc.serie
            )
        );

        const combinedDisciplines = [
          ...updatedExistingDisciplines,
          ...missingDefaultDisciplines
        ];

        return {
          selectedDisciplines: combinedDisciplines
        };
      }

      // Para criação: usar apenas as disciplinas padrão únicas
      return {
        selectedDisciplines: defaultDisciplinesSelected
      };
    });
  };

  handleSeriesChange = selectedOptions => {
    let selectedSeries = [];

    if (this.state.isMultiSerie) {
      // Modo multisseriado: pode ser array
      selectedSeries = selectedOptions || [];
    } else {
      // Modo único: sempre pega o primeiro item (se houver)
      selectedSeries = selectedOptions ? [selectedOptions] : [];
    }

    const serieIds = selectedSeries.map(serie => serie.value);

    this.setState(
      state => ({
        selectedSeries,
        // Manter apenas disciplinas não-padrão ao mudar séries
        selectedDisciplines: state.selectedDisciplines.filter(
          item => !item.isDefault
        )
      }),
      () => {
        // Atualizar nome sugerido
        this.updateSuggestedName();

        // Carregar disciplinas padrão
        if (serieIds.length > 0) {
          this.loadDefaultDisciplinesForMultipleSeries(serieIds);
        } else {
          this.setState({
            selectedDisciplines: []
          });
        }
      }
    );
  };

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  // MODIFICADA: Incluir sigla e complemento no objeto enviado
  enviar(value) {
    if (value.start && value.end) {
      this.setState({ creating: true });

      if (value.start && typeof value.start !== "string") {
        let month = value.start.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.start.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        value.start = `${value.start.getFullYear()}-${month}-${day}`;
      }

      if (value.end && typeof value.end !== "string") {
        let month = value.end.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.end.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        value.end = `${value.end.getFullYear()}-${month}-${day}`;
      }

      const { start, end } = this.gerarDatasDoAnoLetivo(value.year);

      const obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        sigla: value.sigla,
        complemento: value.complemento,
        type: "closed",
        group_id: this.state.group_id,
        region_id: this.state.region_id,
        school_id: this.state.school_id,
        period_id: value.period_id,
        start, // Usar data gerada automaticamente
        end, // Usar data gerada automaticamente
        external_id: value.external_id,
        class: true,
        disciplines: this.state.selectedDisciplines
          .map(item => ({
            serie_id: item.serie,
            discipline_id: item.discipline
          }))
          .filter(item => item.serie_id && item.discipline_id)
          .map(e => JSON.stringify(e))
          .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
          .map(e => JSON.parse(e))
      };

      axios
        .post(`${URL.api}community/room/insert`, obj, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            toastr.success("Sucesso", "Turma criada com sucesso");
            this.props.history.push("/classroom/list");
            this.setState({ creating: false });
          },
          error => {
            toastr.error("Falha", "Falha ao criar turma");
            this.setState({ creating: false });
          }
        );
    }
  }

  // MODIFICADA: Incluir sigla e complemento no objeto de atualização
  atualizar(value) {
    if (value.start && value.end) {
      this.setState({ creating: true });
      if (value.start && typeof value.start !== "string") {
        let month = value.start.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.start.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        value.start = `${value.start.getFullYear()}-${month}-${day}`;
      }

      if (value.end && typeof value.end !== "string") {
        let month = value.end.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.end.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        value.end = `${value.end.getFullYear()}-${month}-${day}`;
      }

      let disciplinesAux = this.state.selectedDisciplines
        .map(item => ({ serie_id: item.serie, discipline_id: item.discipline }))
        .filter(item => item.serie_id && item.discipline_id);
      disciplinesAux = disciplinesAux.filter(
        a => !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true),
        Object.create(null)
      );

      const obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        sigla: value.sigla, // NOVO: Incluir sigla
        complemento: value.complemento, // NOVO: Incluir complemento
        type: "closed",
        group_id: this.state.group_id,
        region_id: this.state.region_id,
        school_id: this.state.school_id,
        period_id: value.period_id,
        start: value.start,
        end: value.end,
        external_id: value.external_id,
        class: true,
        disciplines: disciplinesAux
      };

      axios
        .post(`${URL.api}community/room/update/${value.id}`, obj, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            toastr.success("Sucesso", "Turma editada com sucesso");
            this.props.history.push("/classroom/list");
            this.setState({ creating: false });
          },
          error => {
            toastr.error("Falha", "Falha ao editar a turma");
            this.setState({ creating: false });
          }
        );
    }
  }

  addDiscipline() {
    // MODIFICAÇÃO: Atualizar validação para considerar ambos os modos
    if (!this.state.edit && this.state.selectedSeries.length === 0) {
      toastr.error("Erro", "Favor selecionar pelo menos uma série");
      return;
    }

    // NOVA VALIDAÇÃO: Para modo único, garantir que só há uma série
    if (!this.state.isMultiSerie && this.state.selectedSeries.length > 1) {
      toastr.error("Erro", "No modo turma única, selecione apenas uma série");
      return;
    }

    this.setState(state => {
      const prev = [...state.selectedDisciplines];

      // Para turmas não multisseriadas, usar automaticamente a única série selecionada
      // Para turmas multisseriadas, usar a primeira série como padrão
      const defaultSerie = state.selectedSeries[0].value;

      prev.push({
        discipline: null,
        serie: defaultSerie,
        isDefault: false
      });

      return { selectedDisciplines: prev };
    });
  }

  removeDiscipline(index) {
    this.setState(state => {
      const disciplineToRemove = state.selectedDisciplines[index];

      if (disciplineToRemove.isDefault) {
        toastr.error(
          "Erro",
          "Não é possível remover disciplinas padrão da série"
        );
        return state;
      }

      let prev = [...state.selectedDisciplines];
      prev.splice(index, 1);
      return { selectedDisciplines: prev };
    });
  }

  changeDiscipline(index, value) {
    this.setState(state => {
      const disciplineToChange = state.selectedDisciplines[index];

      if (disciplineToChange.isDefault) {
        toastr.error(
          "Erro",
          "Não é possível alterar disciplinas padrão da série"
        );
        return state;
      }

      let prev = [...state.selectedDisciplines];
      prev[index].discipline = value;
      return { selectedDisciplines: prev };
    });
  }

  changeSerie(index, value) {
    // IMPEDIR mudança de série em turmas não multisseriadas
    if (!this.state.isMultiSerie) {
      toastr.error(
        "Erro",
        "Não é possível alterar a série em turmas não multisseriadas"
      );
      return;
    }

    this.setState(state => {
      let prev = [...state.selectedDisciplines];
      prev[index].serie = value;

      return { selectedDisciplines: prev };
    });
  }

  hasMultipleSeries() {
    const validDisciplines = this.state.selectedDisciplines.filter(
      item => item.serie && item.discipline
    );

    if (validDisciplines.length <= 1) {
      return false;
    }

    const uniqueSeries = new Set(validDisciplines.map(item => item.serie));
    return uniqueSeries.size > 1;
  }

  handleCustomFormSubmit(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    if (
      this.customFormRef.current &&
      !this.customFormRef.current.checkValidity()
    ) {
      this.customFormRef.current.reportValidity();
      return;
    }

    const { customForm } = this.state;

    // VALIDAÇÕES ATUALIZADAS (sigla removida da obrigatoriedade)

    if (!customForm.name.trim()) {
      toastr.error("Erro", "Favor preencher o campo Nome");
      return;
    }

    if (!customForm.period_id) {
      toastr.error("Erro", "Favor preencher o campo Período");
      return;
    }

    if (!customForm.year) {
      toastr.error("Erro", "Favor selecionar o ano letivo");
      return;
    }

    if (!customForm.start) {
      toastr.error("Erro", "Favor preencher o campo Começo");
      return;
    }

    if (!customForm.end) {
      toastr.error("Erro", "Favor preencher o campo Fim");
      return;
    }

    if (new Date(customForm.start) >= new Date(customForm.end)) {
      toastr.error("Erro", "A data de fim deve ser posterior à data de início");
      return;
    }

    this.enviarCustomForm(customForm);
  }

  // MODIFICADA: Incluir sigla e complemento no envio do formulário customizado
  enviarCustomForm(value) {
    if (value.start && value.end) {
      this.setState({ creating: true });

      let formattedStart = value.start;
      let formattedEnd = value.end;

      if (value.start && typeof value.start !== "string") {
        let month = value.start.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.start.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        formattedStart = `${value.start.getFullYear()}-${month}-${day}`;
      }

      if (value.end && typeof value.end !== "string") {
        let month = value.end.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }

        let day = value.end.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        formattedEnd = `${value.end.getFullYear()}-${month}-${day}`;
      }

      const obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        sigla: value.sigla, // NOVO: Incluir sigla
        complemento: value.complemento, // NOVO: Incluir complemento
        type: "closed",
        group_id: this.state.group_id,
        region_id: this.state.region_id,
        school_id: this.state.school_id,
        period_id: parseInt(value.period_id),
        start: formattedStart,
        end: formattedEnd,
        class: true,
        disciplines: this.state.selectedDisciplines
          .map(item => ({
            serie_id: item.serie,
            discipline_id: item.discipline
          }))
          .filter(item => item.serie_id && item.discipline_id)
          .map(e => JSON.stringify(e))
          .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
          .map(e => JSON.parse(e))
      };

      if (this.state.edit && this.state.room && this.state.room.id) {
        obj.id = this.state.room.id;
      }

      const apiUrl = this.state.edit
        ? `${URL.api}community/room/update/${this.state.room.id}`
        : `${URL.api}community/room/insert`;

      const successMessage = this.state.edit
        ? "Turma editada com sucesso (Custom Form)"
        : "Turma criada com sucesso (Custom Form)";

      const errorMessage = this.state.edit
        ? "Falha ao editar turma (Custom Form)"
        : "Falha ao criar turma (Custom Form)";

      axios
        .post(apiUrl, obj, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            toastr.success("Sucesso", successMessage);
            this.props.history.push("/classroom/list");
            this.setState({ creating: false });
          },
          error => {
            toastr.error("Falha", errorMessage);
            this.setState({
              creating: false,
              customForm: {
                name: "",
                sigla: "", // NOVO: Reset sigla
                complemento: "", // NOVO: Reset complemento
                period_id: "",
                start: "",
                end: ""
              }
            });
          }
        );
    }
  }

  toggleReviewMode() {
    this.setState(prevState => ({
      isReviewMode: !prevState.isReviewMode
    }));
  }

  // MODIFICADA: Incluir sigla e complemento nos dados de revisão
  getReviewData() {
    const { customForm } = this.state;

    const selectedGroup = this.state.optionsGroup.find(
      g => g.value === this.state.group_id
    );
    const selectedRegion = this.state.optionsRegion.find(
      r => r.value === this.state.region_id
    );
    const selectedSchool = this.state.optionsSchool.find(
      s => s.value === this.state.school_id
    );
    const selectedPeriod = this.state.optionsPeriod.find(
      p => p.value == customForm.period_id
    );

    const disciplinesWithNames = this.state.selectedDisciplines
      .map(item => {
        const serie = this.state.series.find(s => s.value === item.serie);
        const discipline = this.state.disciplines.find(
          d => d.value === item.discipline
        );
        return {
          serie: serie ? serie.label : "N/A",
          discipline: discipline ? discipline.label : "N/A",
          serie_id: item.serie,
          discipline_id: item.discipline,
          isDefault: item.isDefault || false
        };
      })
      .filter(item => item.serie_id && item.discipline_id);

    return {
      // NO GETREVIEWDATA - atualizar o basic object:
      basic: {
        name: customForm.name,
        sigla: customForm.sigla,
        complemento: customForm.complemento,
        period: selectedPeriod ? selectedPeriod.name : "N/A",
        year: customForm.year, // NOVO: Adicionar ano letivo
        start: customForm.start,
        end: customForm.end,
        type: "closed",
        class: true
      },
      location: {
        group: selectedGroup ? selectedGroup.name : "N/A",
        region: selectedRegion ? selectedRegion.name : "N/A",
        school: selectedSchool ? selectedSchool.name : "N/A"
      },
      disciplines: disciplinesWithNames,
      user: {
        loggedUser: this.props.user.user.id,
        userName: this.props.user.user.name || "N/A"
      },
      selectedSeries:
        this.state.selectedSeries.length > 0
          ? this.state.selectedSeries.map(s => s.label).join(" / ")
          : "Nenhuma série selecionada"
    };
  }

  // MODIFICADA: Mostrar sigla e complemento na tela de revisão
  // MODIFICAÇÃO: Atualizar renderReviewScreen para mostrar série nas disciplinas
  renderReviewScreen() {
    const reviewData = this.getReviewData();

    return (
      <div>
        <h5 className="mb-4">
          {this.state.edit ? "Revisão dos Dados - Edição" : "Revisão dos Dados"}
        </h5>

        {/* Basic Information */}
        <CCard className="mb-3">
          <CCardHeader>
            <h6 className="mb-0">Informações Básicas</h6>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6">
                <strong>Nome:</strong> {reviewData.basic.name}
              </CCol>
              <CCol md="6">
                <strong>Período:</strong> {reviewData.basic.period}
              </CCol>
            </CRow>
            <CRow className="mt-2">
              <CCol md="6">
                <strong>Sigla:</strong> {reviewData.basic.sigla || "N/A"}
              </CCol>
              <CCol md="6">
                {/* CORREÇÃO: Agora mostra as séries corretamente */}
                <strong>Séries:</strong> {reviewData.selectedSeries}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Location Information */}
        <CCard className="mb-3">
          <CCardHeader>
            <h6 className="mb-0">Localização</h6>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="4">
                <strong>Grupo:</strong> {reviewData.location.group}
              </CCol>
              <CCol md="4">
                <strong>Regional:</strong> {reviewData.location.region}
              </CCol>
              <CCol md="4">
                <strong>Escola:</strong> {reviewData.location.school}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Disciplines Information - MODIFICAÇÃO: Adicionar coluna de série */}
        <CCard className="mb-3">
          <CCardHeader className="d-flex align-items-center">
            <h6 className="mb-0">
              Disciplinas ({reviewData.disciplines.length})
            </h6>
          </CCardHeader>
          <CCardBody>
            {reviewData.disciplines.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      {/* MOSTRAR CABEÇALHO DE SÉRIE APENAS PARA TURMAS MULTISSERIADAS */}
                      {this.state.isMultiSerie && <th>Série</th>}
                      <th>Disciplina</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviewData.disciplines.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.isDefault ? (
                            <CBadge color="secondary" className="py-2 px-2">
                              <i className="fa fa-lock mr-1"></i>
                              Padrão
                            </CBadge>
                          ) : (
                            <CBadge color="primary" className="py-2 px-2">
                              <i className="fa fa-plus mr-1"></i>
                              Adicional
                            </CBadge>
                          )}
                        </td>
                        {/* MOSTRAR COLUNA DE SÉRIE APENAS PARA TURMAS MULTISSERIADAS */}
                        {this.state.isMultiSerie && <td>{item.serie}</td>}
                        <td>{item.discipline}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">Nenhuma disciplina selecionada</p>
            )}

            {!this.state.isReviewMode && (
              <div className="mt-4 d-flex justify-content-end">
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => {
                    if (
                      this.customFormRef.current &&
                      !this.customFormRef.current.checkValidity()
                    ) {
                      this.customFormRef.current.reportValidity();
                      return;
                    }

                    const { customForm } = this.state;

                    // Validações atualizadas
                    if (!customForm.name.trim()) {
                      toastr.error("Erro", "Favor preencher o campo Nome");
                      return;
                    }

                    if (!customForm.period_id) {
                      toastr.error("Erro", "Favor preencher o campo Período");
                      return;
                    }

                    // NA VALIDAÇÃO DO BOTÃO REVISAR - substituir validações de data por:
                    if (!customForm.year) {
                      toastr.error("Erro", "Favor selecionar o ano letivo");
                      return;
                    }

                    // MODIFICAÇÃO: Validação atualizada para considerar o interruptor
                    if (
                      !this.state.edit &&
                      this.state.selectedSeries.length === 0
                    ) {
                      toastr.error(
                        "Erro",
                        "Favor selecionar pelo menos uma série"
                      );
                      return;
                    }

                    // NOVA VALIDAÇÃO: Para modo único, garantir que só há uma série
                    if (
                      !this.state.isMultiSerie &&
                      this.state.selectedSeries.length > 1
                    ) {
                      toastr.error(
                        "Erro",
                        "No modo turma única, selecione apenas uma série"
                      );
                      return;
                    }

                    this.toggleReviewMode();
                  }}
                  disabled={this.state.creating}
                >
                  {this.state.creating ? (
                    <CSpinner size="sm" color="white" />
                  ) : (
                    <>
                      <i className="fa fa-eye mr-2"></i>
                      Revisar
                    </>
                  )}
                </CButton>
              </div>
            )}
          </CCardBody>
        </CCard>

        <div className="mt-4">
          <CButton
            color="secondary"
            className="mr-2"
            onClick={() => this.toggleReviewMode()}
          >
            <i className="fa fa-arrow-left mr-2"></i>
            Voltar para Edição
          </CButton>

          <CButton
            color="primary"
            onClick={() => {
              this.handleCustomFormSubmit({ preventDefault: () => {} });
            }}
            disabled={this.state.creating}
          >
            {this.state.creating ? (
              <CSpinner size="sm" color="white" />
            ) : (
              <>
                <i className="fa fa-cloud-upload mr-2"></i>
                Confirmar e Salvar
              </>
            )}
          </CButton>
        </div>
      </div>
    );
  }

  // MODIFICAÇÃO: Atualizar a renderização das disciplinas para mostrar corretamente o status
  renderDisciplinesSection() {
    const {
      selectedSeries,
      selectedDisciplines,
      disciplines,
      series,
      isMultiSerie
    } = this.state;

    // Agrupar disciplinas por tipo para melhor visualização
    const defaultDisciplines = selectedDisciplines.filter(
      item => item.isDefault
    );
    const additionalDisciplines = selectedDisciplines.filter(
      item => !item.isDefault
    );

    // Agrupar disciplinas padrão por série
    const defaultDisciplinesBySerie = {};
    defaultDisciplines.forEach(item => {
      if (!defaultDisciplinesBySerie[item.serie]) {
        defaultDisciplinesBySerie[item.serie] = [];
      }
      defaultDisciplinesBySerie[item.serie].push(item);
    });

    return (
      <CFormGroup>
        <strong className="text-primary">Séries e Disciplinas</strong>

        {/* Disciplinas Padrão */}
        {selectedSeries.length > 0 && (
          <CFormGroup>
            <CLabel>
              Disciplinas Padrão das Séries Selecionadas
              <CBadge color="info" className="ml-2">
                Não editável
              </CBadge>
            </CLabel>

            {Object.keys(defaultDisciplinesBySerie).length > 0 ? (
              Object.entries(defaultDisciplinesBySerie).map(
                ([serieId, discList]) => {
                  const serie = series.find(s => s.value === parseInt(serieId));
                  return (
                    <div key={`serie-${serieId}`} className="mb-3">
                      <strong className="text-primary">
                        {serie ? serie.label : "Série não encontrada"}:
                      </strong>
                      <div className="mt-1">
                        {discList.map((item, index) => {
                          const discipline = disciplines.find(
                            d => d.value === item.discipline
                          );
                          return (
                            <CBadge
                              key={`default-${serieId}-${index}`}
                              color="secondary"
                              className="mr-2 mb-2 p-2"
                              style={{ fontSize: "0.9em" }}
                            >
                              <i className="fa fa-lock mr-1"></i>
                              {discipline
                                ? discipline.label
                                : "Disciplina não encontrada"}
                            </CBadge>
                          );
                        })}
                      </div>
                    </div>
                  );
                }
              )
            ) : (
              <div className="text-muted small">
                Nenhuma disciplina padrão definida para as séries selecionadas
              </div>
            )}
          </CFormGroup>
        )}

        {/* Disciplinas Adicionais */}
        {selectedSeries.length > 0 && (
          <CFormGroup>
            <CLabel>Disciplinas Adicionais</CLabel>
            {additionalDisciplines.map((item, index) => {
              const realIndex = selectedDisciplines.findIndex(
                disc => disc === item
              );

              return (
                <CRow key={`additional-${realIndex}`} className="mb-3">
                  <CCol md={isMultiSerie ? "6" : "10"}>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-book"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder="Disciplina Adicional"
                        options={disciplines}
                        value={disciplines.find(
                          option => option.value === item.discipline
                        )}
                        classNamePrefix="select"
                        onChange={e =>
                          this.changeDiscipline(realIndex, e.value)
                        }
                        isDisabled={this.state.creating}
                      />
                    </CInputGroup>
                  </CCol>

                  {isMultiSerie && (
                    <CCol md="4">
                      <CInputGroup className="input-prepend">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-graduation-cap"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={item.serie || ""}
                          onChange={e =>
                            this.changeSerie(
                              realIndex,
                              parseInt(e.target.value)
                            )
                          }
                          disabled={this.state.creating}
                        >
                          <option value="">Selecione a série</option>
                          {selectedSeries.map(serie => (
                            <option key={serie.value} value={serie.value}>
                              {serie.label}
                            </option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </CCol>
                  )}

                  <CCol md="2">
                    <CButton
                      variant="outline"
                      color="danger"
                      onClick={() => this.removeDiscipline(realIndex)}
                      disabled={this.state.creating}
                    >
                      <i className="fa fa-trash"></i>
                    </CButton>
                  </CCol>
                </CRow>
              );
            })}

            <div className="d-flex align-items-center">
              <CButton
                variant="outline"
                color="primary"
                onClick={() => this.addDiscipline()}
                disabled={selectedSeries.length === 0 || this.state.creating}
              >
                <i className="fa fa-plus mr-2"></i>
                Adicionar Disciplina
              </CButton>

              {!isMultiSerie && selectedSeries.length > 0 && (
                <span className="text-info ml-3">
                  <i className="fa fa-info-circle mr-1"></i>
                  Disciplinas extras serão associadas à série{" "}
                  {selectedSeries[0].label}
                </span>
              )}
            </div>
          </CFormGroup>
        )}

        {selectedSeries.length === 0 && (
          <div className="alert alert-info">
            <i className="fa fa-info-circle mr-2"></i>
            Selecione pelo menos uma série para visualizar as disciplinas padrão
            e adicionar disciplinas extras.
          </div>
        )}
      </CFormGroup>
    );
  }

  getFields() {
    return [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "period_id",
        label: "Período",
        type: "select",
        required: true,
        options: this.state.optionsPeriod,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      },
      {
        name: "start",
        label: "Começo",
        type: "date",
        required: true,
        icon: "fa fa-calendar-o",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "end",
        label: "Fim",
        type: "date",
        required: true,
        icon: "fa fa-calendar-o",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "external_id",
        label: "ID Externo",
        type: "text",
        required: false,
        icon: "fa fa-text-width",
        value: "",
        validate: [alphaNumeric]
      }
    ];
  }

  // MODIFICAÇÃO: Atualizar a função classifyDisciplinesFromBackend para ser mais precisa
  classifyDisciplinesFromBackend = (roomDisciplines, selectedSeries) => {
    if (!roomDisciplines || !selectedSeries || selectedSeries.length === 0) {
      return [];
    }

    const classifiedDisciplines = [];
    const seriesIds = selectedSeries.map(serie => serie.value);

    roomDisciplines.forEach(item => {
      // Verificar se é uma disciplina padrão para a série específica
      const isDefault = seriesIds.some(serieId => {
        const defaultIds = this.defaultDisciplinesBySerie[serieId] || [];
        return (
          defaultIds.includes(item.discipline_id) && item.serie_id === serieId
        );
      });

      classifiedDisciplines.push({
        serie: item.serie_id,
        discipline: item.discipline_id,
        isDefault
      });
    });

    return classifiedDisciplines;
  };

  // NOVA FUNÇÃO: Verificar se o ano letivo pode ser alterado
  isAnoLetivoBloqueado() {
    if (!this.state.edit || !this.state.room) {
      return false;
    }

    // Extrair ano da data original
    const originalYear = this.state.room.start
      ? new Date(this.state.room.start).getFullYear()
      : new Date().getFullYear();

    const currentYear = new Date().getFullYear();

    // Bloquear se o ano original for menor que o ano atual (ano passado)
    const isBloqueado = originalYear < currentYear;

    return isBloqueado;
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/classroom/list", to: "/classroom/list" }]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            {/* Mostrar header normal quando NÃO estiver em modo de revisão */}
            {!this.state.isReviewMode && (
              <CCardHeader>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h4 className="card-title mb-0">
                    {this.state.edit ? "Editar Turma" : "Criar Turma"}
                  </h4>
                  {/* NOVO: Interruptor para turma multisseriada - agora compacto */}
                  {this.renderMultiSerieToggle()}
                </div>

                {/* Mensagem de informação abaixo da linha do título e toggle */}
                <small className="form-text text-muted mt-2 w-100 d-block">
                  {this.state.isMultiSerie ? (
                    <span className="text-info">
                      <i className="fa fa-info-circle mr-1"></i>
                      Modo multisseriado ativado - Você pode selecionar
                      múltiplas séries
                    </span>
                  ) : (
                    <span className="text-info">
                      <i className="fa fa-info-circle mr-1"></i>
                      Modo padrão - Apenas uma série por turma
                    </span>
                  )}
                </small>
              </CCardHeader>
            )}

            {/* Mostrar header simplificado quando ESTIVER em modo de revisão */}
            {this.state.isReviewMode && (
              <CCardHeader>
                <h4 className="card-title mb-0">
                  {this.state.edit
                    ? "Revisão - Editar Turma"
                    : "Revisão - Criar Turma"}
                </h4>
                <small className="form-text text-muted">
                  Revise os dados antes de salvar
                </small>
              </CCardHeader>
            )}

            <CCardBody>
              {this.state.isReviewMode ? (
                this.renderReviewScreen()
              ) : (
                <>
                  <form
                    ref={this.customFormRef}
                    onSubmit={this.handleCustomFormSubmit.bind(this)}
                  >
                    {/* ... resto do formulário */}
                    {/* Campo Série - agora controlado pelo interruptor */}
                    <CFormGroup>
                      <CLabel>
                        {this.state.isMultiSerie
                          ? "Selecione as Séries *"
                          : "Selecione a Série *"}
                      </CLabel>
                      <CInputGroup className="mb-3">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-graduation-cap"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <Select
                          placeholder={
                            this.state.isMultiSerie
                              ? "Selecione as séries (múltiplas)"
                              : "Selecione a série"
                          }
                          options={this.state.series}
                          value={this.state.selectedSeries}
                          onChange={this.handleSeriesChange}
                          classNamePrefix="select"
                          isMulti={this.state.isMultiSerie}
                          isDisabled={this.state.creating}
                        />
                      </CInputGroup>
                      <small className="form-text text-muted">
                        {this.state.isMultiSerie
                          ? "Selecione uma ou mais séries para turmas multisseriadas"
                          : "Apenas uma série será selecionada"}
                      </small>
                    </CFormGroup>

                    {/* Resto do formulário mantido igual */}
                    <CFormGroup>
                      <CLabel>Período (Turno) *</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-clock-o"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          name="period_id"
                          value={this.state.customForm?.period_id || ""}
                          onChange={this.handleCustomFormChange.bind(this)}
                          required
                          disabled={this.state.creating}
                        >
                          <option value="">Selecione um período</option>
                          {this.state.optionsPeriod.map(period => (
                            <option key={period.value} value={period.value}>
                              {period.name}
                            </option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </CFormGroup>
                    {/* Campo Sigla (ANTIGO COMPLEMENTO - MANTÉM COMO SELECT) */}
                    <CFormGroup>
                      <CLabel>Sigla</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-tag"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          name="sigla"
                          value={this.state.customForm?.sigla || ""}
                          onChange={this.handleCustomFormChange.bind(this)}
                          disabled={this.state.creating}
                        >
                          <option value="">Selecione uma sigla</option>
                          {this.complementoOptions.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                      <small className="form-text text-muted">
                        Sigla opcional (A, B, C, I, II, III, etc.)
                      </small>
                    </CFormGroup>
                    {/* Campo Nome (agora preenchido automaticamente) */}
                    <CFormGroup>
                      <CLabel>Nome da Turma *</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-text-width"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CInput
                          type="text"
                          name="name"
                          value={this.state.customForm?.name || ""}
                          onChange={this.handleCustomFormChange.bind(this)}
                          placeholder="Nome será gerado automaticamente"
                          required
                          disabled={this.state.creating}
                        />
                      </CInputGroup>
                      <small className="form-text text-muted">
                        Nome gerado automaticamente, mas pode ser editado
                        manualmente
                      </small>
                    </CFormGroup>

                    <CFormGroup>
                      <CLabel>Ano Letivo *</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-calendar"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        {this.isAnoLetivoBloqueado() ? (
                          // Quando bloqueado, usar CInput com as classes corretas do CoreUI
                          <CInput
                            type="text"
                            value={this.state.customForm?.year || ""}
                            readOnly
                            className="flex-1"
                            style={{
                              backgroundColor: "#e9ecef",
                              cursor: "not-allowed"
                            }}
                          />
                        ) : (
                          // Quando não bloqueado, mostrar o select normal
                          <CSelect
                            name="year"
                            value={this.state.customForm?.year || ""}
                            onChange={this.handleCustomFormChange.bind(this)}
                            required
                            disabled={this.state.creating}
                            className="flex-1"
                          >
                            <option value="">Selecione o ano letivo</option>
                            {this.gerarOpcoesAnoLetivo().map(year => (
                              <option key={year.value} value={year.value}>
                                {year.label}
                              </option>
                            ))}
                          </CSelect>
                        )}
                      </CInputGroup>
                      <small className="form-text text-muted">
                        Período letivo de 01/01 até 31/12 do ano selecionado
                        {this.isAnoLetivoBloqueado() && (
                          <span className="text-warning ml-2">
                            <i className="fa fa-lock mr-1"></i>
                            Ano letivo não pode ser alterado para anos passados
                          </span>
                        )}
                      </small>
                    </CFormGroup>
                  </form>

                  {["G"].includes(this.props.general.active_roles.type) && (
                    <CFormGroup>
                      <CLabel>Grupo</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-group"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          className="flex-1"
                          value={this.state.group_id}
                          onChange={e =>
                            this.setState({
                              group_id: parseInt(e.target.value),
                              region_id: null,
                              school_id: null
                            })
                          }
                          disabled={
                            this.props.general.active_roles.group_id !== null ||
                            this.state.edit
                          }
                        >
                          <option value={null}>Grupo</option>
                          {this.state.optionsGroup.map(group => (
                            <option value={group.value}>{group.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </CFormGroup>
                  )}
                  {["G", "U"].includes(
                    this.props.general.active_roles.type
                  ) && (
                    <CFormGroup>
                      <CLabel>Regional</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-group"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          className="flex-1"
                          value={this.state.region_id}
                          onChange={e =>
                            this.setState({
                              region_id: parseInt(e.target.value),
                              school_id: null
                            })
                          }
                          disabled={
                            this.props.general.active_roles.region_id !==
                              null || this.state.edit
                          }
                        >
                          <option value={null}>Regional</option>
                          {this.state.optionsRegion
                            .filter(
                              region => region.group_id === this.state.group_id
                            )
                            .map(region => (
                              <option value={region.value}>
                                {region.name}
                              </option>
                            ))}
                        </CSelect>
                      </CInputGroup>
                    </CFormGroup>
                  )}
                  {["G", "U", "R"].includes(
                    this.props.general.active_roles.type
                  ) && (
                    <CFormGroup>
                      <CLabel>Escola</CLabel>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-group"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          className="flex-1"
                          value={this.state.school_id}
                          onChange={e =>
                            this.setState({
                              school_id: parseInt(e.target.value)
                            })
                          }
                          disabled={
                            this.props.general.active_roles.school_id !==
                              null || this.state.edit
                          }
                        >
                          <option value={null}>Escola</option>
                          {this.state.optionsSchool
                            .filter(
                              school =>
                                school.region_id === this.state.region_id
                            )
                            .map(school => (
                              <option value={school.value}>
                                {school.name}
                              </option>
                            ))}
                        </CSelect>
                      </CInputGroup>
                    </CFormGroup>
                  )}

                  {/* Seção de disciplinas (mantida na parte inferior) */}
                  {this.renderDisciplinesSection()}

                  {/* NOVO: Botão Revisar na parte inferior */}
                  {!this.state.isReviewMode && (
                    <div className="mt-4 d-flex justify-content-end">
                      <CButton
                        color="primary"
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => {
                          if (
                            this.customFormRef.current &&
                            !this.customFormRef.current.checkValidity()
                          ) {
                            this.customFormRef.current.reportValidity();
                            return;
                          }

                          const { customForm } = this.state;

                          // Validações atualizadas
                          if (!customForm.name.trim()) {
                            toastr.error(
                              "Erro",
                              "Favor preencher o campo Nome"
                            );
                            return;
                          }

                          if (!customForm.period_id) {
                            toastr.error(
                              "Erro",
                              "Favor preencher o campo Período"
                            );
                            return;
                          }

                          // NA VALIDAÇÃO DO BOTÃO REVISAR - substituir validações de data por:
                          if (!customForm.year) {
                            toastr.error(
                              "Erro",
                              "Favor selecionar o ano letivo"
                            );
                            return;
                          }

                          // MODIFICAÇÃO: Validação atualizada para considerar o interruptor
                          if (
                            !this.state.edit &&
                            this.state.selectedSeries.length === 0
                          ) {
                            toastr.error(
                              "Erro",
                              "Favor selecionar pelo menos uma série"
                            );
                            return;
                          }

                          // NOVA VALIDAÇÃO: Para modo único, garantir que só há uma série
                          if (
                            !this.state.isMultiSerie &&
                            this.state.selectedSeries.length > 1
                          ) {
                            toastr.error(
                              "Erro",
                              "No modo turma única, selecione apenas uma série"
                            );
                            return;
                          }

                          this.toggleReviewMode();
                        }}
                        disabled={this.state.creating}
                      >
                        {this.state.creating ? (
                          <CSpinner size="sm" color="white" />
                        ) : (
                          <>
                            <i className="fa fa-eye mr-2"></i>
                            Revisar
                          </>
                        )}
                      </CButton>
                    </div>
                  )}
                </>
              )}
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomCreate);
